<template>
  <div class="designer-services">
    <div v-if="designerServices.length" class="flex-container align-right mbm">
      <a :href="urls.newServiceUrl" class="button small">Ajouter un nouveau service</a>
    </div>
    <table v-if="services.length" class="table designer-services">
      <thead>
        <tr>
          <th width="220px">Type de design</th>
          <th>
            <table class="table designer-services__table no-border mbn ptm pbm">
              <tr>
                <th width="45%" class="pln">Titre</th>
                <th width="15%">Prix</th>
                <th width="20%">Actif</th>
                <th width="20%"></th>
              </tr>
            </table>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in services" :key="index">
          <td class="prm ptm pbm u-vertically-align-top">
            <div class="designer-services__image_container text-center">
              <img :src="item.service.image" alt="Service Image" />
              <p>{{ item.service.designTypeDisplayName }}</p>
            </div>
          </td>
          <td colspan="4" class="prm">
            <table class="table designer-services__table no-border mbn ptm pbm">
              <tr>
                <td width="45%" class="pln prs">
                    <a :href="item.service.designerServiceUrl">{{ item.service.title }}</a>
                </td>
                <td width="15%" class="prs">{{ item.service.price }}</td>
                <td width="20%" class="prs">
                  <span
                    :class="{
                      'label success': item.service.active === true,
                      'label alert': item.service.active === false,
                    }"
                  >
                    {{ item.service.active ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td width="20%" class="prs">
                  <a :href="item.service.editUrl">Modifiez</a>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="prs pls ptm">
                  <p class="mbn" v-html="descriptionText(item)" />
                  <span class="readMore" @click="onToggle(index)">
                    {{ item.readMore ? 'Read More' : 'Read Less' }}
                  </span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="frame frame--padding-tight mbl">
      <h2>Bienvenue aux services de créateurs</h2>
      <p>
        DesignCrowd vous donne désormais la possibilité de proposer des services de conception directement aux clients et de travailler en tête-à-tête avec eux. Vous définissez le service de conception et le prix, nous mettons le service sur votre portefeuille de designers et vous obtenons des clients. Une fois qu'un client achète le service, vous en êtes informé et vous travaillez en tête-à-tête avec le client.
        <br />
        Cliquez simplement pour ajouter un service de conception ci-dessous pour commencer. C'est si simple!
      </p>
      <div class="align-right flex-container">
        <a :href="urls.newServiceUrl" class="button">Ajouter un service de conception</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    designerServices: {
      type: Array,
      default: () => [],
    },
    apiBaseUrl: {
      type: String,
      default: undefined,
    },
    urls: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      services: [],
    };
  },
  mounted() {
    this.initialiseItems();
  },
  watch: {
    designerServices() {
      this.initialiseItems();
    },
  },
  methods: {
    initialiseItems() {
      this.services = this.designerServices.map((service) => ({
        service,
        readMore: service.description.length > 150,
      }));
    },
    descriptionText(item) {
      return item.readMore
        ? item.service.description.substring(0, 150)
        : item.service.description;
    },
    onToggle(index) {
      this.services[index].readMore = !this.services[index].readMore;
    },
  },
};
</script>
